"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SectionLede = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _theming = require("@storybook/theming");

var _styles = require("./shared/styles");

var _excluded = ["meta", "inverse", "heading", "copy", "actions", "headingWrapper"];

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var ContentWrapper = (0, _theming.styled)("div", process.env.NODE_ENV === "production" ? {
  target: "ev2tpyy5"
} : {
  target: "ev2tpyy5",
  label: "ContentWrapper"
})("display:flex;flex-direction:column;align-items:flex-start;@media (min-width: ", _styles.breakpoints[2], "px){flex-direction:row;gap:80px;}");
var ContentContainer = (0, _theming.styled)("div", process.env.NODE_ENV === "production" ? {
  target: "ev2tpyy4"
} : {
  target: "ev2tpyy4",
  label: "ContentContainer"
})(_styles.pageMargins, ";display:flex;align-items:center;flex-direction:column;");
var SectionHeading = (0, _theming.styled)("h2", process.env.NODE_ENV === "production" ? {
  target: "ev2tpyy3"
} : {
  target: "ev2tpyy3",
  label: "SectionHeading"
})(_styles.marketing.heading, ";color:", function (props) {
  return props.inverse ? _styles.color.lightest : _styles.color.darkest;
}, ";flex:1;min-width:0;@media (min-width: ", _styles.breakpoints[1], "px){", _styles.marketing.hero2, ";}@media (min-width: ", _styles.breakpoints[2], "px){", _styles.marketing.hero1, ";text-align:left;}");
var LedeParagraph = (0, _theming.styled)("p", process.env.NODE_ENV === "production" ? {
  target: "ev2tpyy2"
} : {
  target: "ev2tpyy2",
  label: "LedeParagraph"
})(_styles.marketing.textLarge, ";color:", function (props) {
  return props.inverse ? _styles.color.lightest : _styles.color.darkest;
}, ";margin-top:1.25rem;margin-bottom:0;@media (min-width: ", _styles.breakpoints[2], "px){text-align:left;margin-top:0.5rem;}");
var LedeRight = (0, _theming.styled)("div", process.env.NODE_ENV === "production" ? {
  target: "ev2tpyy1"
} : {
  target: "ev2tpyy1",
  label: "LedeRight"
})(process.env.NODE_ENV === "production" ? {
  name: "1swjwel",
  styles: "flex:1;min-width:0;&>*:not(:last-child){margin-bottom:20px;}"
} : {
  name: "1swjwel",
  styles: "flex:1;min-width:0;&>*:not(:last-child){margin-bottom:20px;}",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
var Actions = (0, _theming.styled)("div", process.env.NODE_ENV === "production" ? {
  target: "ev2tpyy0"
} : {
  target: "ev2tpyy0",
  label: "Actions"
})(process.env.NODE_ENV === "production" ? {
  name: "egn49m",
  styles: "display:flex;align-items:center;&>*:not(:last-child){margin-right:20px;}"
} : {
  name: "egn49m",
  styles: "display:flex;align-items:center;&>*:not(:last-child){margin-right:20px;}",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

var SectionLede = function SectionLede(_ref) {
  var meta = _ref.meta,
      inverse = _ref.inverse,
      heading = _ref.heading,
      copy = _ref.copy,
      actions = _ref.actions,
      headingWrapper = _ref.headingWrapper,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(ContentContainer, props, /*#__PURE__*/_react["default"].createElement(ContentWrapper, null, /*#__PURE__*/_react["default"].createElement(SectionHeading, {
    inverse: inverse,
    as: headingWrapper
  }, heading), /*#__PURE__*/_react["default"].createElement(LedeRight, null, /*#__PURE__*/_react["default"].createElement(LedeParagraph, {
    inverse: inverse
  }, copy), actions && /*#__PURE__*/_react["default"].createElement(Actions, null, actions), meta)));
};

exports.SectionLede = SectionLede;